import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchWorkflowRoutesAssignedPermissions } from "../../contents/redux/actions/workflowRouteActions";
import { Tooltip } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "../utilities/cssmodules/ViewWorkflow.module.css";

const ViewWorkflowContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workflow = location.state?.workflow;

  const [groupedPermissions, setGroupedPermissions] = useState({});

  const assignedPermissions = useSelector(
    (state) => state.workflowRoutes.workflowRoutePermissions,
  );
  const fetchLoading = useSelector((state) => state.loading);
  const fetchError = useSelector((state) => state.error);

  // Go back to previous component
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (!workflow) {
      navigate("/workflowmanagement");
    }
  }, [workflow, navigate]);

  useEffect(() => {
    if (workflow?.id) {
      dispatch(fetchWorkflowRoutesAssignedPermissions(workflow.id));
    }
  }, [dispatch, workflow]);

  // Group permissions by roleName and sequence
  useEffect(() => {
    if (assignedPermissions && Array.isArray(assignedPermissions)) {
      const grouped = assignedPermissions.reduce((acc, workflowRoute) => {
        const key = `${workflowRoute.roleName} (Sequence ${workflowRoute.sequence})`;
        if (!acc[key]) {
          acc[key] = [];
        }
        if (
          workflowRoute.permissionName &&
          !acc[key].includes(workflowRoute.permissionName)
        ) {
          acc[key].push(workflowRoute.permissionName);
        }
        return acc;
      }, {});
      console.log("Grouped Permissions:", grouped);
      setGroupedPermissions(grouped);
    }
  }, [assignedPermissions]);

  return (
    <div className={styles["componentWrapper"]}>
      <div className={styles["componentTitle"]}>
        <div className={styles["flexRowContainer"]}>
          <div className={styles["flexRowCustom1"]}>
            <span
              className={styles["titleBackButton"]}
              onClick={goBack}
              aria-label="Go Back"
            >
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>
            <span>View Workflow</span>
          </div>
        </div>
      </div>
      <div className={styles["wrapper"]}>
        <div className={styles["topInfoText"]}>
          View details, routes, and permissions for <b>{workflow?.name}</b>{" "}
          workflow
        </div>
        <div className={styles["componentContentViewWrapper"]}>
          <div className={styles["componentContentViewSection"]}>
            <div className={styles["componentContentViewSectionHeader"]}>
              Details
            </div>
            <div className={styles["componentContentViewSectionGrid"]}>
              <div className={styles["componentContentViewSectionGridItem"]}>
                <div className={styles["componentContentViewSectionGridTitle"]}>
                  Name
                </div>
                <div className={styles["componentContentViewSectionGridData"]}>
                  {workflow?.name || "N/A"}
                </div>
              </div>
              <div className={styles["componentContentViewSectionGridItem"]}>
                <div className={styles["componentContentViewSectionGridTitle"]}>
                  Description
                </div>
                <div className={styles["componentContentViewSectionGridData"]}>
                  {workflow?.description || "No description provided"}
                </div>
              </div>
              <div className={styles["componentContentViewSectionGridItem"]}>
                <div className={styles["componentContentViewSectionGridTitle"]}>
                  Max amount (USD)
                </div>
                <div className={styles["componentContentViewSectionGridData"]}>
                  {workflow?.maxAmount ?? "Non monetary"}
                </div>
              </div>
              <div className={styles["componentContentViewSectionGridItem"]}>
                <div className={styles["componentContentViewSectionGridTitle"]}>
                  Creation date
                </div>
                <div className={styles["componentContentViewSectionGridData"]}>
                  {workflow?.createdOn
                    ? new Date(workflow.createdOn).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "N/A"}
                </div>
              </div>
            </div>
          </div>
          <div className={styles["componentContentViewSection"]}>
            <div className={styles["componentContentViewSectionHeader"]}>
              Routes and Permissions
            </div>
            {fetchLoading ? (
              <div className={styles["loading"]}>Loading permissions...</div>
            ) : fetchError ? (
              <div className={styles["error"]}>Error: {fetchError}</div>
            ) : Object.keys(groupedPermissions).length > 0 ? (
              <div className={styles["componentContentViewPermissionsWrapper"]}>
                {Object.keys(groupedPermissions)
                  .sort((a, b) => {
                    const seqA = parseInt(a.match(/Sequence (\d+)/)[1]);
                    const seqB = parseInt(b.match(/Sequence (\d+)/)[1]);
                    return seqA - seqB;
                  })
                  .map((key) => (
                    <div
                      key={key}
                      className={styles["componentContentViewPermission"]}
                    >
                      <div
                        className={styles["componentContentViewPermissionCategory"]}
                      >
                        {key.split(" (Sequence")[0]}
                      </div>
                      <div
                        className={styles["componentContentViewPermissionData"]}
                      >
                        {groupedPermissions[key]?.length > 0
                          ? groupedPermissions[key].join(", ")
                          : "No permissions assigned"}
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <div className={styles["componentContentViewPermissionEmpty"]}>
                No permissions assigned to routes yet
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewWorkflowContent;
